import { useErrorMessage, toast } from '@sentinel/web-core';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { endpoints } from '@/core/api/endpoints';
import { keys } from '@/core/query/query-keys';

/** The Google accounts linked to one's own account (ADR 0014), each with «Scollega»: signing in
 *  with Google again links it back. Shown in the user card. */
export function LinkedIdentities() {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const errorMessage = useErrorMessage();
  const identities = useQuery({
    queryKey: keys.ownIdentities,
    queryFn: endpoints.users.ownIdentities,
  });
  const unlink = useMutation({
    mutationFn: (identityId: string) => endpoints.users.unlinkOwnIdentity(identityId),
    onSuccess: () => {
      toast('ok', t('shell.user.google.unlinked'));
      void queryClient.invalidateQueries({ queryKey: keys.ownIdentities });
    },
    onError: (error) => toast('att', errorMessage(error)),
  });
  const items = identities.data?.items ?? [];
  if (items.length === 0) return null;
  return (
    <div className="uc-sec">
      <p className="mlabel">{t('shell.user.google.title')}</p>
      {items.map((identity) => (
        <p key={identity.id} style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <span className="note grow">{identity.email}</span>
          <button
            type="button"
            className="btn sm ghost"
            disabled={unlink.isPending}
            onClick={() => unlink.mutate(identity.id)}
          >
            {t('shell.user.google.unlink')}
          </button>
        </p>
      ))}
    </div>
  );
}
